var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _path41, _path42, _line, _path43, _path44, _path45, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfBigPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 556,
    viewBox: "0 0 272 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60079 25.0439C1.60156 34.8555 1.60156 47.6995 1.60156 73.3875V481.819C1.60156 507.507 1.60156 520.351 6.60079 530.163C10.9982 538.793 18.015 545.81 26.6455 550.207C36.457 555.207 49.3011 555.207 74.9891 555.207H197.551C223.239 555.207 236.083 555.207 245.894 550.207C254.525 545.81 261.541 538.793 265.939 530.163C270.938 520.351 270.938 507.507 270.938 481.819V73.3875C270.938 47.6995 270.938 34.8555 265.939 25.0439C261.541 16.4135 254.525 9.39667 245.894 4.99923C236.083 0 223.239 0 197.551 0H74.9891C49.3011 0 36.457 0 26.6455 4.99923C18.015 9.39667 10.9982 16.4135 6.60079 25.0439ZM5.86828 70.8275C5.86828 47.529 5.86828 35.8798 10.4025 26.981C14.3908 19.1533 20.7549 12.7893 28.5825 8.8009C37.4814 4.26672 49.1306 4.26672 72.4291 4.26672H108.269C108.782 4.26672 109.193 5.05291 109.478 5.59758C109.521 5.67924 109.56 5.75547 109.597 5.8228C109.959 6.48224 110.66 6.92926 111.465 6.92926H160.541C161.346 6.92926 162.047 6.48223 162.409 5.8228C162.446 5.75546 162.486 5.67923 162.528 5.59756C162.813 5.0529 163.225 4.26672 163.737 4.26672H200.111C223.409 4.26672 235.058 4.26672 243.957 8.8009C251.785 12.7893 258.149 19.1533 262.137 26.981C266.671 35.8798 266.671 47.529 266.671 70.8275V484.379C266.671 507.678 266.671 519.327 262.137 528.226C258.149 536.053 251.785 542.417 243.957 546.406C235.058 550.94 223.409 550.94 200.111 550.94H72.4291C49.1306 550.94 37.4814 550.94 28.5825 546.406C20.7549 542.417 14.3908 536.053 10.4025 528.226C5.86828 519.327 5.86828 507.678 5.86828 484.379V70.8275Z",
    fill: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272 177.003C272 176.414 271.522 175.937 270.933 175.937H270.403V242.046H270.933C271.522 242.046 272 241.568 272 240.979V177.003Z",
    fill: "#E5E7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 107.428C0.000976562 106.986 0.359153 106.628 0.800986 106.628H1.59785V127.954H0.800986C0.359152 127.954 0.000976562 127.596 0.000976562 127.154V107.428Z",
    fill: "#E5E7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 147.414C0.000976562 146.972 0.359153 146.614 0.800986 146.614H1.59785V189.265H0.800986C0.359152 189.265 0.000976562 188.907 0.000976562 188.465V147.414Z",
    fill: "#E5E7EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 200.728C0.000976562 200.286 0.359153 199.928 0.800986 199.928H1.59785V242.579H0.800986C0.359152 242.579 0.000976562 242.221 0.000976562 241.779V200.728Z",
    fill: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5491_418060)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5491_418060)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.642 11.6094H13.8389V542.342H258.642V11.6094Z",
    fill: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5491_418060)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 244,
    height: 530,
    rx: 16,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7939,
    y: 534.2,
    width: 90.7097,
    height: 3.38469,
    rx: 1.69234,
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3866 81H73.1146L73.5012 93.2387H71.7772C70.9332 89.3947 69.8612 86.8907 68.5599 85.7307C67.2585 84.5693 64.5212 83.9893 60.3479 83.9893H56.3372V120.848C56.3372 123.624 56.7705 125.344 57.6399 126.008C58.5065 126.673 60.4052 127.111 63.3372 127.32V128.656H42.3399V127.32C45.3879 127.087 47.2865 126.585 48.0372 125.815C48.7865 125.045 49.1625 123.108 49.1625 120.004V83.9893H45.1186C41.1319 83.9893 38.4185 84.564 36.9759 85.712C35.5345 86.8614 34.4492 89.3707 33.7226 93.2387H31.9639L32.3866 81Z",
    fill: "#9CA3AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242 81.5C242 81.7769 207.748 82 165.5 82C123.244 82 89 81.7769 89 81.5C89 81.2231 123.244 81 165.5 81C207.748 81 242 81.2231 242 81.5Z",
    fill: "#9CA3AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242 94.4991C242 94.7755 207.748 95 165.5 95C123.244 95 89 94.7755 89 94.4991C89 94.2246 123.244 94 165.5 94C207.748 94 242 94.2246 242 94.4991Z",
    fill: "#9CA3AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M242 107.499C242 107.775 207.748 108 165.5 108C123.244 108 89 107.775 89 107.499C89 107.225 123.244 107 165.5 107C207.748 107 242 107.225 242 107.499Z",
    fill: "#9CA3AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242 120.499C242 120.775 207.748 121 165.5 121C123.244 121 89 120.775 89 120.499C89 120.225 123.244 120 165.5 120C207.748 120 242 120.225 242 120.499Z",
    fill: "#9CA3AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242 133.499C242 133.775 207.748 134 165.5 134C123.244 134 89 133.775 89 133.499C89 133.225 123.244 133 165.5 133C207.748 133 242 133.225 242 133.499Z",
    fill: "#9CA3AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242 146.499C242 146.775 207.748 147 165.5 147C123.244 147 89 146.775 89 146.499C89 146.225 123.244 146 165.5 146C207.748 146 242 146.225 242 146.499Z",
    fill: "#9CA3AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242 159.499C242 159.775 207.748 160 165.5 160C123.244 160 89 159.775 89 159.499C89 159.223 123.244 159 165.5 159C207.748 159 242 159.223 242 159.499Z",
    fill: "#9CA3AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M242 172.501C242 172.775 194.537 173 136.004 173C77.4493 173 30 172.775 30 172.501C30 172.225 77.4493 172 136.004 172C194.537 172 242 172.225 242 172.501Z",
    fill: "#9CA3AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242 397.501C242 397.775 194.537 398 136.004 398C77.4493 398 30 397.775 30 397.501C30 397.225 77.4493 397 136.004 397C194.537 397 242 397.225 242 397.501Z",
    fill: "#9CA3AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242 185.501C242 185.777 194.537 186 136.004 186C77.4493 186 30 185.777 30 185.501C30 185.225 77.4493 185 136.004 185C194.537 185 242 185.225 242 185.501Z",
    fill: "#9CA3AF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242 410.501C242 410.777 194.537 411 136.004 411C77.4493 411 30 410.777 30 410.501C30 410.225 77.4493 410 136.004 410C194.537 410 242 410.225 242 410.501Z",
    fill: "#9CA3AF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242 198.501C242 198.777 194.537 199 136.004 199C77.4493 199 30 198.777 30 198.501C30 198.225 77.4493 198 136.004 198C194.537 198 242 198.225 242 198.501Z",
    fill: "#9CA3AF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242 423.501C242 423.777 194.537 424 136.004 424C77.4493 424 30 423.777 30 423.501C30 423.225 77.4493 423 136.004 423C194.537 423 242 423.225 242 423.501Z",
    fill: "#9CA3AF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242 462.501C242 462.777 194.537 463 136.004 463C77.4493 463 30 462.777 30 462.501C30 462.225 77.4493 462 136.004 462C194.537 462 242 462.225 242 462.501Z",
    fill: "#9CA3AF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242 211.501C242 211.775 194.537 212 136.004 212C77.4493 212 30 211.775 30 211.501C30 211.225 77.4493 211 136.004 211C194.537 211 242 211.225 242 211.501Z",
    fill: "#9CA3AF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M242 436.501C242 436.775 194.537 437 136.004 437C77.4493 437 30 436.775 30 436.501C30 436.225 77.4493 436 136.004 436C194.537 436 242 436.225 242 436.501Z",
    fill: "#9CA3AF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242 475.501C242 475.775 194.537 476 136.004 476C77.4493 476 30 475.775 30 475.501C30 475.225 77.4493 475 136.004 475C194.537 475 242 475.225 242 475.501Z",
    fill: "#9CA3AF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242 224.499C242 224.775 194.537 225 136.004 225C77.4493 225 30 224.775 30 224.499C30 224.225 77.4493 224 136.004 224C194.537 224 242 224.225 242 224.499Z",
    fill: "#9CA3AF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242 449.499C242 449.775 194.537 450 136.004 450C77.4493 450 30 449.775 30 449.499C30 449.225 77.4493 449 136.004 449C194.537 449 242 449.225 242 449.499Z",
    fill: "#9CA3AF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M242 488.499C242 488.775 194.537 489 136.004 489C77.4493 489 30 488.775 30 488.499C30 488.225 77.4493 488 136.004 488C194.537 488 242 488.225 242 488.499Z",
    fill: "#9CA3AF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242 501.499C242 501.775 194.537 502 136.004 502C77.4493 502 30 501.775 30 501.499C30 501.225 77.4493 501 136.004 501C194.537 501 242 501.225 242 501.499Z",
    fill: "#9CA3AF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242 237.501C242 237.777 194.537 238 136.004 238C77.4493 238 30 237.777 30 237.501C30 237.225 77.4493 237 136.004 237C194.537 237 242 237.225 242 237.501Z",
    fill: "#9CA3AF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M242 250.501C242 250.775 194.537 251 136.004 251C77.4493 251 30 250.775 30 250.501C30 250.225 77.4493 250 136.004 250C194.537 250 242 250.225 242 250.501Z",
    fill: "#9CA3AF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M242 289.501C242 289.775 222.075 290 197.502 290C172.92 290 153 289.775 153 289.501C153 289.225 172.92 289 197.502 289C222.075 289 242 289.225 242 289.501Z",
    fill: "#9CA3AF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242 302.501C242 302.777 222.074 303 197.502 303C172.92 303 153 302.777 153 302.501C153 302.225 172.92 302 197.502 302C222.074 302 242 302.225 242 302.501Z",
    fill: "#9CA3AF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242 328.501C242 328.777 222.074 329 197.502 329C172.92 329 153 328.777 153 328.501C153 328.225 172.92 328 197.502 328C222.074 328 242 328.225 242 328.501Z",
    fill: "#9CA3AF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242 315.499C242 315.777 222.074 316 197.502 316C172.92 316 153 315.777 153 315.499C153 315.225 172.92 315 197.502 315C222.074 315 242 315.225 242 315.499Z",
    fill: "#9CA3AF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M242 341.499C242 341.777 222.074 342 197.502 342C172.92 342 153 341.777 153 341.499C153 341.225 172.92 341 197.502 341C222.074 341 242 341.225 242 341.499Z",
    fill: "#9CA3AF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M242 354.499C242 354.777 222.074 355 197.502 355C172.92 355 153 354.777 153 354.499C153 354.225 172.92 354 197.502 354C222.074 354 242 354.225 242 354.499Z",
    fill: "#9CA3AF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M242 367.501C242 367.775 222.074 368 197.502 368C172.92 368 153 367.775 153 367.501C153 367.225 172.92 367 197.502 367C222.074 367 242 367.225 242 367.501Z",
    fill: "#9CA3AF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242 380.501C242 380.775 222.074 381 197.502 381C172.92 381 153 380.775 153 380.501C153 380.225 172.92 380 197.502 380C222.074 380 242 380.225 242 380.501Z",
    fill: "#9CA3AF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32 376.209C32 380.628 35.5817 384.209 40 384.209H122.41C126.829 384.209 130.41 380.628 130.41 376.209V297C130.41 292.582 126.829 289 122.41 289H40C35.5817 289 32 292.582 32 297V376.209Z",
    fill: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5491_418060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 327,
    width: 83,
    height: 50
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.763 376.062H81.2267C69.4414 376.02 55.544 375.972 40.04 375.918C40.04 375.72 40.04 375.522 40.04 375.323L66.8547 327.067L89.1214 358.382L102.652 341.752L122.761 376.028C122.761 376.039 122.763 376.051 122.763 376.062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5491_418060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.04 376.062H122.763V327.067H40.04V376.062Z",
    fill: "#9CA3AF"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5231 324.62C87.6111 324.62 84.4404 321.45 84.4404 317.538C84.4404 313.626 87.6111 310.455 91.5231 310.455C95.4338 310.455 98.6044 313.626 98.6044 317.538C98.6044 321.45 95.4338 324.62 91.5231 324.62Z",
    fill: "#9CA3AF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2227 376.737V376.326C39.208 364.729 39.1933 352.122 39.1773 338.789C39.1733 332.119 39.1693 325.269 39.1653 318.271C39.164 314.774 39.164 311.238 39.1626 307.671C39.1613 305.887 39.1613 304.095 39.1613 302.295V299.591V298.235V297.557V297.217V297.046V296.961V296.919V296.898C39.0893 296.969 39.06 296.998 39.0587 296.998C39.0547 296.998 39.2 296.85 39.3466 296.702C39.4933 296.555 39.6413 296.407 39.6453 296.407C39.6467 296.407 39.644 296.41 39.64 296.415C70.152 296.439 98.6986 296.462 122.78 296.481L123.185 296.482L123.183 296.885C123.099 320.767 123.027 340.659 122.977 354.627C122.932 361.522 122.897 366.953 122.873 370.706C122.852 372.515 122.836 373.919 122.825 374.914C122.817 375.358 122.809 375.706 122.804 375.981C122.796 376.21 122.789 376.327 122.781 376.327L122.78 376.326C122.775 376.321 122.769 376.231 122.763 376.062H122.78L122.761 376.029C122.76 375.999 122.759 375.969 122.759 375.935C122.753 375.651 122.745 375.287 122.736 374.826C122.724 373.813 122.708 372.383 122.689 370.541C122.664 366.766 122.629 361.305 122.585 354.371C122.535 340.545 122.465 320.885 122.38 297.287C98.5026 297.306 70.2693 297.329 40.0986 297.353V297.557V298.235V299.591V302.295C40.0986 304.095 40.0973 305.887 40.0973 307.671C40.0973 311.238 40.096 314.774 40.096 318.271C40.092 325.269 40.088 332.119 40.084 338.789C40.068 351.738 40.0533 364.003 40.04 375.323L39.6307 376.062H81.2266C88.1693 376.086 94.3787 376.107 99.7507 376.125C107.017 376.171 112.747 376.206 116.708 376.233C118.643 376.253 120.144 376.269 121.207 376.281C121.692 376.29 122.073 376.297 122.371 376.303C122.636 376.311 122.773 376.318 122.78 376.326C122.789 376.334 122.665 376.342 122.417 376.349C122.131 376.355 121.764 376.363 121.296 376.373C120.253 376.383 118.777 376.399 116.877 376.421C112.937 376.445 107.239 376.481 100.012 376.527C85.3747 376.578 64.556 376.649 39.6307 376.735L39.2227 376.737Z",
    fill: "#D1D5DB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 58.5,
    x2: 258,
    y2: 58.5,
    stroke: "#E5E7EB"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M113.264 23.3879H158.736C163.725 23.3879 167.77 27.4328 167.77 32.4224C167.77 37.412 163.725 41.4569 158.736 41.4569H113.264C108.275 41.4569 104.23 37.412 104.23 32.4224C104.23 27.4328 108.275 23.3879 113.264 23.3879Z",
    fill: "#F5F5F6",
    stroke: "#E5E7EB",
    strokeWidth: 0.459539
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.424 37.5281C161.241 37.5281 163.525 35.2443 163.525 32.4272C163.525 29.61 161.241 27.3263 158.424 27.3263C155.607 27.3263 153.323 29.61 153.323 32.4272C153.323 35.2443 155.607 37.5281 158.424 37.5281Z",
    fill: "#E0E1E4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M158.423 35.1889C159.948 35.1889 161.185 33.9524 161.185 32.4271C161.185 30.9018 159.948 29.6653 158.423 29.6653C156.898 29.6653 155.661 30.9018 155.661 32.4271C155.661 33.9524 156.898 35.1889 158.423 35.1889Z",
    fill: "#A8AEB8"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3732,
    y: 12.7955,
    width: 243.254,
    height: 529.409,
    rx: 33.0671,
    stroke: "#E5E7EB",
    strokeWidth: 1.06668
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5491_418060"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.8398,
    y: 12.2622,
    width: 244.321,
    height: 530.476,
    rx: 33.6004,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5491_418060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244.803,
    height: 530.673,
    fill: "white",
    transform: "translate(13.8389 12.2622)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5491_418060"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 244,
    height: 530,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBigPreviewIcon);
export default __webpack_public_path__ + "static/media/pdf-big-preview-icon.9a702dfaf57fc761c68c1d3e1f36638c.svg";
export { ForwardRef as ReactComponent };